////
/// ============================================================================
/// COMPONENT / Map
/// ============================================================================
///
/// @group components
////

import {Loader} from "@googlemaps/js-api-loader"
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import debounce from "../utils/debounce";

export default () => {
    const content = document.querySelector(".js-map");

    if (!content) {
        return;
    }

    const loader = new Loader({
        apiKey: content.dataset.key,
        version: "weekly",
    });

    loader
        .load()
        .then(google => {
            let options = {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
            };

            if (content.dataset.lat && content.dataset.lng) {
                options.center = {
                    lat: parseFloat(content.dataset.lat),
                    lng: parseFloat(content.dataset.lng)
                };
            }

            if (content.dataset.zoom) {
                options.zoom = parseInt(content.dataset.zoom);
            }

            const map = new google.maps.Map(content, options);
            const markersBounds = new google.maps.LatLngBounds();
            const infoWindow = new google.maps.InfoWindow();

            const markers = JSON.parse(content.dataset.locations).map((location) => {
                const marker = new google.maps.Marker({
                    position: location.position
                });

                markersBounds.extend(marker.position);

                marker.addListener("click", () => {
                    let title = location.content.title ? `<a href="${location.content.permalink}" class="c-map_title">${location.content.title}</a>` : '';
                    //let title = location.content.title ? `<span class="c-map_title">${location.content.title}</span>` : '';
                    let address = location.content.address ? `<div class="c-map_address">${location.content.address}</div>` : '';
                    let businessHours = location.content.business_hours ? `<div class="c-map_business-hours">${location.content.business_hours}</div>` : '';
                    let gmap = location.content.gmap ? `<a href="${location.content.gmap}" class="c-btn -s" target="_blank"><svg role="img" focusable="false"><use xlink:href="#icon--map"></use></svg>${i18n["stores.map"]}</a>` : '';
                    let website = location.content.website ? `<a href="${location.content.website}" class="c-btn -s" target="_blank"><svg role="img" focusable="false"><use xlink:href="#icon--link"></use></svg>${i18n["stores.website"]}</a>` : '';
                    let email = location.content.email ? `<a href="mailto:${location.content.email}" class="c-map_email"><svg role="img" focusable="false"><use xlink:href="#icon--email"></use></svg>${location.content.email}</a>` : '';
                    let phone = location.content.phone ? `<a href="tel:${location.content.phone}" class="c-map_phone"><svg role="img" focusable="false"><use xlink:href="#icon--phone"></use></svg>${location.content.phone}</a>` : '';

                    let content = `<div class="c-map_content">${title}${address}${businessHours}<div class="c-map_actions">${gmap}${website}</div><div class="c-map_contacts">${email}${phone}</div></div>`;

                    infoWindow.setContent(content);
                    infoWindow.open(map, marker);
                });

                return marker;
            });

            new MarkerClusterer({
                markers,
                map
            });

            if (!options.center) {
                let centerMap = () => {
                    let breakpoint = getComputedStyle(content).getPropertyValue('--breakpoint');

                    map.fitBounds(markersBounds);

                    if ('desktop' === breakpoint) {
                        let center = markersBounds.getCenter();

                        let listener = google.maps.event.addListener(map, "idle", () => {
                            map.setCenter({
                                lat: center.lat(),
                                lng: center.lng(),
                            });

                            google.maps.event.removeListener(listener);
                        });
                    }
                };

                window.addEventListener('resize', debounce(centerMap));
                centerMap();
            }
        });
};
